module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAOCAYAAAD5YeaVAAAAs0lEQVQoU+WQvQ7BABSFz2ERi1ASb+ENGG0Gg1FSi6FWL8HaDhZNjAaDzcgbeAsJJRax1BE/1SqNB3C3e893cu89RKxKjsoXYJIC2luLm6jMaJMfKUcfSwoVEWulUTt0eQyYEHaVKZywIFANRAGrfRZ1mDzfZg94qrSxwwxCI34WiLlXRBMt+nfYsDUGYX6A4QrX67HDgq0BiX4i+BQkDN8eNBwpbvIsvpj/gn/Fx29xJZmuX9VF5B35KowAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/order/icon_5.png
// module id = zyqY
// module chunks = 1